

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

import { FieldType } from '@/lib/types';

interface FieldDisplayProps {
  label: string;
  value: unknown;
  type?: FieldType;
}

export function FieldDisplay({ label, value, type = 'text' }: FieldDisplayProps) {
  // Handle different value types
  let displayValue: ReactNode = '—';

  if (type === 'image' && typeof value === 'string' && value) {
    displayValue = (
      <Box
        component="img"
        src={value}
        alt={label}
        sx={{
          width: 60,
          height: 60,
          borderRadius: 1,
          objectFit: 'cover',
          border: '1px solid',
          borderColor: 'divider',
          mt: 0.5
        }}
      />
    );
  } else if (typeof value === 'string' || typeof value === 'number') {
    displayValue = value;
  } else if (Array.isArray(value)) {
    displayValue = value.length > 0 ? value.join(', ') : '—';
  } else if (typeof value === 'boolean') {
    displayValue = value ? 'Yes' : 'No';
  }

  return (
    <Stack spacing={0.5}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          fontSize: '0.7rem'
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.primary',
          whiteSpace: type === 'textarea' ? 'pre-wrap' : 'normal',
          minHeight: type === 'textarea' ? 'auto' : undefined,
        }}
      >
        {displayValue}
      </Typography>
    </Stack>
  );
}
